<style scoped>

  * {
    margin: 0;
    padding: 0;
  }

  #main {
    height: 100vh;
    background: #F5F5F5 !important;   
    display: grid;
    margin: 0;
    align-items: center;
    justify-content: center;
  }

  #container {
    width: 350px;
    height: 490px;    
    border-radius: 8px;
    background-color: #FFFFFF;
    border-style: solid;
    border-width: 1px;
    border-color: #DDDDDE;
  }

  #title {
    margin-top: 15px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  .logo {
    width: 250px;
    height: 160px;
    margin-bottom: 0px;
  }

  #login-form {
    padding: 16px 20px 20px 20px;
  }

  #submit-button {
    margin-top: 25px;
    margin-bottom: 32px;
    background-color: #D45A3B !important;
  }

</style>

<template>

  <div id="main" class="app-bg">

    <div id="container" class="animated fadeIn">

      <div class="ui middle aligned center aligned grid">

        <div class="column">

          <div v-if="$isStaging" id="title" class="animated flash">
            <div class="ui red large label">Ambiente de Testes</div>
          </div>

          <div v-else id="title">
            Portal Simavet
          </div>

          <div class="ui divider"></div>

          <img class="ui middle aligned logo image" src="/assets/images/logo.png">

          <form id="login-form" @submit.prevent="onLogin()" class="ui form">

            <div class="ui field">
              <div class="ui left icon large input">
                <i class="user icon"></i>
                <input type="text" placeholder="E-mail" v-model="login">
              </div>
            </div>

            <div class="ui field">
              <div class="ui left icon large input">
                <i class="key icon"></i>
                <input type="password" placeholder="Senha" v-model="password">
              </div>
            </div>

            <button type="submit" id="submit-button" class="ui fluid large black button" :class="{ 'loading': loading }">
              ENTRAR
            </button>

            <a class="grey text clickable" @click="showPswRecoveryDialog()">
              Esqueci minha senha
            </a>    

          </form>

        </div>

      </div>

    </div>    

    <div id="psw-recovery-dialog" class="ui tiny modal psw-recovery-modal">

      <div class="ui header">
        Recuperação de Senha
      </div>

      <div class="content">

        <p class="grey text">Informe seu e-mail para receber instruções para redefinir sua senha</p>

        <form class="ui form m-t-10" @submit.prevent="onPasswordRecovery()">
          <div class="ui field">
            <div class="ui left icon large input">
              <input type="text" placeholder="E-mail" v-model="recoveryEmail">
              <i class="envelope icon"></i>
            </div>
          </div>
        </form>        

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui blue button" :class="{ disabled: !recoveryEmail, loading: recovering }" @click="onPasswordRecovery()">
          <i class="paper plane icon"></i>
          Enviar
        </button>
      </div>

    </div>      

  </div>

</template>

<script>
  
  import AuthService from "@/services/auth-service"

  export default {

    name: "LoginPage",

    data() {
      return {
        login: "",
        password: "",
        loading: false,
        recoveryEmail: "",
        recovering: false,
        authService: new AuthService(),
      }
    },

    beforeDestroy() {
      $(".psw-recovery-modal").remove()
    },

    methods: {

      async onLogin() {

        if (this.loading || !this.validLogin())
          return

        this.loading = true

        try {

          await this.authService.login(this.login, this.password)

          this.$router.push("/")
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }        
      },

      validLogin() {

        let isOk = true

        if (!this.login || !this.password) {
          isOk = false
          this.$msg.info("Informe seu e-mail e sua senha")
        }

        return isOk
      },

      showPswRecoveryDialog() {
        $("#psw-recovery-dialog").modal("show")
      },

      async onPasswordRecovery() {

        if (this.recovering)
          return

        this.recovering = true

        try {

          await this.authService.sendPasswordResetEmail(this.recoveryEmail)

          this.recovering = false

          $("#psw-recovery-dialog").modal("hide")

          this.$msg.success(`E-mail enviado com sucesso para ${this.recoveryEmail}`)

          this.recoveryEmail = ""
          
        } catch (error) {
          
          this.recovering = false          
          this.$errorHandler(error)
        } 
      },
    },
  }

</script>
